// Effectieve status Vlieger Arts: vervalt automatisch naar afwezig na de eindtijd.
export function flightDoctorState(present, until, now = new Date()) {
  const end = until ? new Date(until) : null;
  const active = !!present && (!end || end > now);
  const label = !active ? "Afwezig" : end ? `tot ${end.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" })}` : "Aanwezig";
  return { active, label };
}

// "HH:MM" -> ISO; ligt de tijd vandaag al achter ons, dan morgen.
export function untilFromTime(hhmm) {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  if (d <= new Date()) d.setDate(d.getDate() + 1);
  return d.toISOString();
}
